/**
 * @generated SignedSource<<c8e2719101f02e3f06b683a66b565b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type UploadCreateSeriesMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  metadata: BasicMetadata;
};
export type UploadCreateSeriesMutation$data = {
  readonly createSeries: {
    readonly id: string;
  };
};
export type UploadCreateSeriesMutation = {
  response: UploadCreateSeriesMutation$data;
  variables: UploadCreateSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "createSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadCreateSeriesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UploadCreateSeriesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "75011ecd483f5f080caa2d1d6b28e0fd",
    "id": null,
    "metadata": {},
    "name": "UploadCreateSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation UploadCreateSeriesMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclItem!]!\n) {\n  createSeries(metadata: $metadata, acl: $acl) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "db6323a439ffc86f12dd643881797da9";

export default node;
